"use strict";

(function (global) {

  /**
   * Вызвать метод веб-сервисов.
   * В методы done и error можно передать функции обратного вызова, 
   * которые выполняются тогда, когда будет получен ответ от сервиса. 
   * Если операции веб-сервиса прошли без сбоев, то будет вызвана функция, 
   * переданная в метод done данного deferred-объекта, иначе будет вызвана функция, переданная в метод еrror.
   * Полный ответ сервиса можно получить обратившись к контексту this внутри функции callback.
   * @tutorial services
   * @function WebAccess.services.call
   * @param  {string}   service_method Вызываемый метод веб-сервиса
   * @param  {object}   [opt_params] Параметры веб-сервиса      
   * @param  {string}   [opt_spinnerText] Текст строки прогресса @deprecated
   * @param  {string}   [opt_onCompleteSpinnerText] Текст строки прогресса после выполнения операции @deprecated
   * @param  {boolean}  [opt_hideError] Не отображать ошибку
   * @param  {boolean}  [opt_hideWarning] Не отображать уведомления
   * @return {Deferred} deferred-объект – специальный объект для управления отложенными вызовами.
   * @this {object} result - результат выполнения сервиса содержит полный ответ.
   * @since 5.0.0.4000
   *
   * @example
   * WA.services.call("/Reference.asmx/CreateNewFilter", { "ReferenceCode": WA.current.getReferenceCode(), "Name": displayValue }).success(function (result) {
   *   console.log(result);  //то же самое что this.Result.
       console.log(this.Result);
       console.log(this.Warning);
       console.log(this.Success);
       console.log(this.Error);       
   * }).error(function(error) {
       console.log(error);
     });
   *
   * @example
   * WA.services.call("/Script.asmx/Run",{Name:"WADemoTest","Params": {"id": 10} }).error(function(errorText) { ShowDialog(errorText); } );
   */
  global.services.call = function (service_method, opt_params, opt_spinnerText, opt_onCompleteSpinnerText, opt_hideError, opt_hideWarning) {
    return global.services._call(service_method, opt_params, true, opt_spinnerText, opt_onCompleteSpinnerText, opt_hideError, opt_hideWarning);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Выполнить синхронный вызов методов веб-сервисов.
   * В методы done и error можно передать функции обратного вызова, 
   * которые выполняются тогда, когда будет получен ответ от сервиса. 
   * Если операции веб-сервиса прошли без сбоев, то будет вызвана функция, 
   * переданная в метод done данного deferred-объекта, иначе будет вызвана функция, переданная в метод еrror.
   *
   * @tutorial services   
   * @function WebAccess.services.callSync
   * @param  {string}   service_method Вызываемый метод веб-сервиса
   * @param  {object}   [opt_params] Параметры веб-сервиса
   * @param  {string}   [opt_spinnerText] Текст строки прогресса @deprecated
   * @param  {string}   [opt_onCompleteSpinnerText] Текст строки прогресса после выполнения операции
   * @param  {boolean}   [opt_hideError] Не отображать ошибку @deprecated
   * @param  {boolean}   [opt_hideWarning] Не отображать уведомления
   * @return {Deferred}  deferred-объект – специальный объект для управления отложенными вызовами.
   * @since 5.0.0.4004
   */
  global.services.callSync = function (service_method, opt_params, opt_spinnerText, opt_onCompleteSpinnerText, opt_hideError, opt_hideWarning) {
    return global.services._call(service_method, opt_params, false, opt_spinnerText, opt_onCompleteSpinnerText, opt_hideError, opt_hideWarning);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Вызов сервисов. Базовая функция.
  * @private  
  */
  global.services._call = function (service_method, opt_params, async, opt_spinnerText, opt_onCompleteSpinnerText, opt_hideError, opt_hideWarning) {
    if (!service_method) WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED", "service_method");

    var showHint = function (msg, isError) {      
      ErrorShow(msg, isError);
    }

    if (opt_spinnerText !== false) opt_spinnerText = opt_spinnerText || '';
    if (opt_onCompleteSpinnerText !== false) opt_onCompleteSpinnerText = opt_onCompleteSpinnerText || '';
    opt_hideError = opt_hideError || false;
    opt_hideWarning = opt_hideWarning || false;
    var params = opt_params || {};

    var deferred = jQuery.Deferred();
    deferred.success = deferred.done;
    deferred.error = deferred.fail;

    if (opt_spinnerText !== false) {
      ShowTopSpinner(opt_spinnerText);
    }

    var xhr = $.ajax({
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      url: service_method,
      data: $.toJSON(params),
      async: async,
      cache: false,
      success: function (res) {
        if (!res) {
          deferred.rejectWith({}, ["NO_ANSWER"]);
          if (opt_spinnerText !== false) {
            HideTopSpinner(opt_spinnerText);
          }
          return;
        };

        res = res.d;

        if (!opt_hideWarning && res.Warning !== null) {
          showHint(res.Warning, false);
        }

        if (!res.Success) {
          if (!opt_hideError) {
            ErrorShow(res.Error, true);
          }
          if (opt_spinnerText !== false) {
            HideTopSpinner(opt_spinnerText);
          }
          deferred.rejectWith(res, [res.Error, res]);
        } else {
          if (opt_onCompleteSpinnerText !== false) {
            HideTopSpinner(opt_onCompleteSpinnerText, 2000);
          }
        }

        if (CheckForLoginPage(res)) return;
        deferred.resolveWith(res, [res.Result, res]);
      }, error: function (err) {
        var brokenSessionText;
        if (service_method.indexOf('/ClientStatistic.asmx/writeQueue') === -1) { //#86815
          if (!global.services._isSessionAlive(err.status)) {
            opt_hideError = true;
            brokenSessionText = L('WARN_BROKEN_SESSION');
          }
        } else {
          return;
        }
        
        if (!opt_hideError) showHint(err.responseText, true);
        var errResp = {
          Result: null,
          Success: false,
          Warning: null,
          Error: brokenSessionText || err.responseText
        };
        deferred.rejectWith(errResp, [brokenSessionText || err.responseText, err]);
        if (opt_spinnerText !== false) {
          HideTopSpinner(opt_spinnerText);
        }
      }
    });

    deferred.abort = xhr.abort;
    return deferred;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.services._sessionBrokenDialog = null;
  global.services._sessionRestoredDialog = null;    

  /**
  * @fixme: рефактор плачет по этому
  * @private
  */
  global.services._isSessionAlive = function (statusCode) {

    if (statusCode == 401) {
      return false;
    }

    if (statusCode == 503) {
      WA.CR.inlineHint.show(L('ERROR_DESTRUCTIVE_FAULT'));
      log.error('SESSION', 'Service unavailavble');
      return false;
    }

    if (statusCode == 475) {      
      var dialog = global.services._sessionRestoredDialog;
      if (!!dialog && dialog.isOpened()) {
        dialog.close();
      };
      
      if (!global.services._sessionBrokenDialog) {
        dialog = new WA.CMP.dialogs.MessageBox({ width: 450 });
        dialog.id = '475';
        dialog.isSingleInstance = true;
        dialog.removeDefaultButtons()
        .addButton('reloginLater', L('STAY_ON_PAGE'), function () {
          
        })
        .addButton('Relogin', L('LOGIN_AGAIN'), function () {
          ShowTopSpinner();
          WA.CR.window.openLogin();
        })
        .show(L('WARN_BROKEN_SESSION'), L('WARN_BROKEN_SESSION_DETAILS'), L('WARNING'), 'warning');
      } else {
        dialog = global.services._sessionBrokenDialog;
        dialog.show();
      }
      
      global.services._sessionBrokenDialog = dialog;
      return false;
    } else {      
      var dialog = global.services._sessionBrokenDialog;
      if (!!dialog && dialog.isOpened()) {
        dialog.close();
        if (!global.services._sessionRestoredDialog) {
          dialog = new WA.CMP.dialogs.MessageBox();
          dialog.isSingleInstance = true;
          dialog.removeDefaultButtons()
          .addButton('ReloginLater', L('OK'))
          .show(L('WARN_RESTORED_SESSION'), L('WARN_RESTORED_SESSION_DETAILS'), L('INFO'), 'info');
          
        };
      } else { dialog = global.services._sessionRestoredDialog }
      global.services._sessionRestoredDialog = dialog;
    }
    return true;
  };

  /**
   * Предоставляет инструменты для работы со справочниками, карточками справочников, 
   * а также предоставляет ресурсы для выполнения различных настроек в справочниках, например, работа с фильтрами.
   *
   * @namespace WebAccess.services.reference
   * @since 5.0.0.4004
   */
  global.services.reference = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы со сценариями. Например, позволяет запустить сценарий.
   *
   * @namespace WebAccess.services.script
   * @since 5.0.0.4004
   */
  global.services.script = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с объектами системы DIRECTUM. 
   * Например, позволяет установить пользовательский статус на объекте.
   *
   * @namespace WebAccess.services.entity
   * @since 5.0.0.4200
   */
  global.services.entity = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с задачами. 
   * Например, позволяет создать задачу с вложениями и установить права на вложения задачи.
   *
   * @namespace WebAccess.services.task
   * @since 5.0.0.4200
   */
  global.services.task = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для проведения аутентификации пользователя и его работы с реквизитами. 
   * Например, позволяет сменить пароль пользователя.
   *
   * @namespace WebAccess.services.authenticaion
   * @since 5.2.0.1200
   */
  global.services.authenticaion = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Предоставляет инструменты для работы с папками системы DIRECTUM. 
 * Например, позволяет установить пользовательские статусы на папках.
 *
 * @namespace WebAccess.services.folder
 * @since 5.0.0.4200
 */
  global.services.folder = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с сессией пользователя. 
   * Например, позволяет изменить тему профиля пользователя.
   *
   * @namespace WebAccess.services.session
   * @since 5.0.0.4214
   */
  global.services.session = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с документами.
   *
   * @namespace WebAccess.services.document
   * @since 5.0.0.4218
   */
  global.services.document = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с карточками.
   *
   * @namespace WebAccess.services.cardform
   * @since 5.0.0.7100
   */
  global.services.cardform = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для получения разметки реквизитов на сервере.
   *
   * @namespace WebAccess.services.requisite
   * @since 5.0.0.7100
   */
  global.services.requisite = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
})(window.WebAccess);